<template>
  <div>
    <NavigationBar titel="Datenvisualisierung" isPreview :actions="actions">
      <template v-slot:tab-bar>
        <v-toolbar
          elevation="0"
          dense
          fixed
          :style="{
            'border-bottom-width': 'thin !important',
            'border-color': $vuetify.theme.dark
              ? 'rgb(255,255,255,0.12)'
              : 'rgb(0,0,0,0.12)',
            'border-bottom-style': 'solid !important',
          }"
        >
          <v-chip-group mandatory active-class="primary--text">
            <v-chip
              v-for="tag in tags"
              :key="tag"
              label
              class="font-weight-medium"
            >
              {{ tag }}
            </v-chip>
          </v-chip-group>
        </v-toolbar>
        <v-toolbar
          elevation="0"
          dense
          fixed
          :style="{
            'border-bottom-width': 'thin !important',
            'border-color': $vuetify.theme.dark
              ? 'rgb(255,255,255,0.12)'
              : 'rgb(0,0,0,0.12)',
            'border-bottom-style': 'solid !important',
          }"
        >
          <v-btn depressed class="mr-2"
            ><v-icon left small>mdi-calendar</v-icon>Zeitraum auswählen</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn depressed class="ml-2"
            ><v-icon left small>mdi-fullscreen</v-icon>Vollbild</v-btn
          >
          <v-btn depressed class="ml-2"
            ><v-icon left small>mdi-pencil</v-icon>Bearbeiten</v-btn
          >
          <v-btn depressed class="ml-2"
            ><v-icon left small>mdi-cog</v-icon>Einstellungen</v-btn
          >
        </v-toolbar>
      </template>
    </NavigationBar>
    <section>
      <template>
        <v-container>
          <v-row justify="center" align="center">
            <v-col cols="12"
              ><v-card height="400px"
                ><v-card-text
                  ><div
                    style="background-color: goldenrod"
                  ></div></v-card-text></v-card
            ></v-col>
            <v-col cols="12"
              ><v-card height="400px"
                ><v-card-text
                  ><div
                    style="background-color: goldenrod"
                  ></div></v-card-text></v-card
            ></v-col>
          </v-row>
        </v-container>
      </template>
    </section>
  </div>
</template>

<script>
import NavigationBar from "@/components/_systemwide/NavigationBar.vue";
// import VueApexCharts from "vue-apexcharts";
import { STATS_read } from "@/data/permission-types.js";
export default {
  name: "stats-visualizer",
  components: { NavigationBar },
  data() {
    return {
      actions: [
        {
          title: "Erstellen",
          icon: "mdi-plus",
          permission: `${STATS_read}`,
          actionStyle: "textBtn",
          function: this.createItem,
        },
      ],

      tags: ["Allgemein", "Rückmeldungen", "Veranstaltungsbezogen"],
    };
  },
  methods: {
    addView() {
      alert("a");
    },
  },
};
</script>
